import { render } from "./FeedbackManagement.vue?vue&type=template&id=1ccf0e50&scoped=true&ts=true"
import script from "./FeedbackManagement.vue?vue&type=script&lang=ts"
export * from "./FeedbackManagement.vue?vue&type=script&lang=ts"

import "./FeedbackManagement.vue?vue&type=style&index=0&id=1ccf0e50&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccf0e50"]])

export default __exports__